import { render, staticRenderFns } from "./Karibik.vue?vue&type=template&id=0a3f5c7a&"
import script from "./Karibik.vue?vue&type=script&lang=js&"
export * from "./Karibik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports